import React, { useEffect, useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Select } from 'antd';
import { TWButton } from '../../ui';
import menuApi from '../../../services/menuApi';
import { useSelector } from 'react-redux';
import SlideOver from '../../slide-over/slide-over';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function CategoryUpsertModal({
  show,
  onFormChange,
  onFormSubmit,
  onClickDeleteCategory,
  onCloseUpsert,
  categoryForm,
  errors,
  loading,
}) {
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const [menuList, setMenuList] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);

  const getMenuList = async () => {
    try {
      setInitialLoading(true);
      const query = `?companyid=${globalCompany.id}&pageSize=100&isdeleted=false`;
      const list = await menuApi.list(query);
      if (list.data.data.length > 0) {
        setMenuList(list.data.data);
      }
    } catch (error) {
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    getMenuList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryForm]);

  const footerContent = (
    <div className="grid grid-cols-12 gap-3">
      {categoryForm.id && (
        <TWButton
          variant="danger"
          icon={TrashIcon}
          disabled={loading}
          loading={loading}
          onClick={() => onClickDeleteCategory(categoryForm)}
          className="col-span-2 w-full"
        />
      )}
      <TWButton
        variant="default"
        label="Cancel"
        disabled={loading}
        onClick={() => onCloseUpsert()}
        className={classNames(
          categoryForm.id ? 'col-span-5' : 'col-span-6',
          'w-full',
        )}
      />
      <TWButton
        variant="primary"
        label={categoryForm.id ? 'Edit Category' : 'Add Category'}
        disabled={loading}
        loading={loading}
        onClick={() => onFormSubmit()}
        className={classNames(
          categoryForm.id ? 'col-span-5' : 'col-span-6',
          'w-full',
        )}
      />
    </div>
  );

  return (
    <SlideOver
      show={show}
      onClose={onCloseUpsert}
      title={categoryForm.id ? 'Edit Category' : 'Create Category'}
      subtitle="Organize products under clear and ordered category names."
      footer={footerContent}
    >
      <div className="space-y-4">
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700 dark:text-slate-400"
          >
            Category Name
          </label>
          <div className="mt-1">
            <input
              value={categoryForm.name}
              onChange={(e) => {
                onFormChange(e.target.value, 'name');
              }}
              maxLength={30}
              type="text"
              name="name"
              id="name"
              className="block w-full appearance-none rounded-md border dark:text-slate-200 dark:bg-slate-800 border-gray-300 px-3 py-2 placeholder-black placeholder-opacity-25 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-md dark:focus:border-sky-400 dark:focus:ring-sky-400 dark:placeholder:text-slate-500"
              placeholder="e.g ''Salads, Pizzas, Drinks''"
            />
            <div className="h-2 mt-1 text-xs">
              {errors.name && (
                <p className="text-red-700">Category name can not be empty</p>
              )}
            </div>
          </div>
        </div>
        <div>
          <label
            htmlFor="description"
            className="block text-sm font-medium text-gray-700 dark:text-slate-400"
          >
            Description
          </label>
          <div className="mt-1">
            <input
              value={categoryForm.description}
              onChange={(e) => {
                onFormChange(e.target.value, 'description');
              }}
              maxLength={400}
              type="text"
              name="description"
              id="description"
              className="block w-full appearance-none rounded-md border dark:text-slate-200 dark:bg-slate-800 border-gray-300 px-3 py-2 placeholder-black placeholder-opacity-25 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-md dark:focus:border-sky-400 dark:focus:ring-sky-400 dark:placeholder:text-slate-500"
              placeholder="e.g ''Fresh and Healthy Salads, Delicious Pizzas''"
            />
          </div>
        </div>
        <div>
          <label
            htmlFor="menuid"
            className="block text-sm font-medium text-gray-700 dark:text-slate-400 mb-1"
          >
            Menu
          </label>
          <Select
            loading={initialLoading}
            size="large"
            style={{
              width: '100%',
            }}
            placeholder="Please select Menu"
            defaultValue={categoryForm.menuid}
            onChange={(val) => onFormChange(val, 'menuid')}
            options={menuList?.map((x) => ({
              label: x.name,
              value: x.id,
            }))}
          />
        </div>
      </div>
    </SlideOver>
  );
}
